/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useMemo } from "react";
import fr from "../locales/fr.json";
import en from "../locales/en.json";

const messages: Record<string, Record<string, unknown>> = { fr, en };

function getNested(obj: unknown, path: string): string | undefined {
  const parts = path.split(".");
  let current: unknown = obj;
  for (const p of parts) {
    if (current == null || typeof current !== "object") return undefined;
    current = (current as Record<string, unknown>)[p];
  }
  return typeof current === "string" ? current : undefined;
}

export type getTType = (key: string) => string;

export function getT(locale: "fr" | "en") {
  const dict = messages[locale] ?? messages.fr;
  return (key: string): string => getNested(dict, key) ?? key;
}

type I18nContextValue = { locale: "fr" | "en"; t: (key: string) => string };

const I18nContext = createContext<I18nContextValue | null>(null);

export function I18nProvider({
  locale,
  t,
  children,
}: {
  locale: "fr" | "en";
  t: (key: string) => string;
  children: React.ReactNode;
}) {
  const value = useMemo(() => ({ locale, t }), [locale, t]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    return { locale: "fr", t: (k: string) => k };
  }
  return ctx;
}
